import React from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import {ref, onValue} from 'firebase/database'
import StartFirebase from '../firebaseConfig/config';
import CountUp from 'react-countup';

import 
{ 
    StatsContainer,
    StatsH1,
    StatsH2,
    StatsNumber,
    StatsCard,
    StatsIcon,
    StatsP,
    StatsWrapper,
    StatsContentWrapper,
    StatsA,
    StatsContent,
    StatsRating,
    StatsNumberContent

} from './StatsElements'

const db = StartFirebase()

export class StatsSection extends React.Component{
    constructor(){
        super()
        this.state = {
            finishedGameData: 0
        }
    }

    componentDidMount(){
        const dbRef = ref(db, '/finished_games')

        onValue(dbRef, (snapshot) => {
            let records = [];
            snapshot.forEach(childSnapshot => {
                let keyName = childSnapshot.key;
                let data = childSnapshot.val();
                records.push({"key": keyName, "data": data});
            });
            this.setState({finishedGameData: records.length});
        });
    }

    render()
    {
        return (
            <StatsContainer id="stats">
                <StatsH1>Statistiky</StatsH1>
                <StatsWrapper>
                    <StatsCard>
                        <StatsContentWrapper>
                            <StatsNumberContent>
                                <StatsNumber>
                                    <CountUp end={this.state.finishedGameData} duration={3} useEasing={true}/>
                                </StatsNumber>
                            </StatsNumberContent>
                            
                            <StatsContent>
                                <StatsH2>DOHRANÝCH HER</StatsH2>
                            </StatsContent>
                        </StatsContentWrapper>
                    </StatsCard>
                </StatsWrapper>
            </StatsContainer>
        )
    }
}

export default StatsSection